import createApi from 'api/createApi';

export const tags = {
	portal_test: 'search/portal_test',
};

export const semanticSearchApi = createApi({
	reducerPath: 'semanticSearchApi',

	endpoints: (builder) => ({
		portalTest: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/search/portal_test',
				body,
				jsonType: true,
			}),
			providesTags: [tags.portal_test],
		}),
	}),
});

export const { portalTest } = semanticSearchApi.endpoints;

export default semanticSearchApi;
